import type { GraphQLError } from 'graphql';
import { ApolloError } from 'apollo-boost';
import { ServerError, ServerParseError } from 'apollo-link-http-common';

export const isGraphQLError = (error: unknown): error is GraphQLError => {
	return !!error && typeof error === 'object' && 'message' in error && typeof (error as any).message === 'string';
};

export const isGraphQLErrorArray = (error: unknown): error is GraphQLError[] => {
	return Array.isArray(error) && error.length > 0 && isGraphQLError(error[0]);
};

export const isApolloError = (error: unknown): error is ApolloError => {
	return error instanceof ApolloError;
};

export const isApolloGraphQLError = (error: unknown): error is ApolloError => {
	return isApolloError(error) && Array.isArray(error.graphQLErrors) && error.graphQLErrors.length > 0;
};

export const isApolloNetworkError = (error: unknown): error is ApolloError => {
	return isApolloError(error) && error.networkError && typeof error.networkError.message === 'string';
};

export const isStringError = (error: unknown): error is string => {
	return typeof error === 'string';
};

export const isStringErrorArray = (error: unknown): error is string[] => {
	return Array.isArray(error) && typeof error[0] === 'string';
};

export const isServerError = (error: Error | ServerError | ServerParseError): error is ServerError => {
	return 'statusCode' in error;
};
